import { SvgIcon } from "@mui/material"

import { ReactComponent as ContactIconSVG } from "../../assets/svg/contact.svg"
import { ReactComponent as PhoneIconSVG } from "../../assets/svg/phone.svg"

export const ContactIcon = (props) => (
  <SvgIcon component={ContactIconSVG} inheritViewBox {...props} />
)

export const PhoneIcon = (props) => (
  <SvgIcon component={PhoneIconSVG} inheritViewBox {...props} />
)
